import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const HomeLauncherMenu = () => (
  <RibbonMenu
    className="aridhia-home-launcher-menu"
    name="home"
    icon="home"
    message="fair.launcher.home"
    url={`#${relativeUrl(urls.HOME)}`}
  />
);

export default HomeLauncherMenu;
